import Validator from "../../helpers/validation";

const CustomTextarea = {
    props: {
        title: {
            default: "",
            type: String,
        },

        name: {
            default: "",
            type: String,
        },

        validation: {
            type: Array,
            default() {
                return [];
            },
        },

        required: {
            default: false,
            type: Boolean,
        },

        placeholder: {
            default: "",
            type: String,
        },

        modelValue: {
            type: [String, Number],
        },
    },

    data() {
        return {
            textarea_value: null,

            error_message: null,

            valid: false,

            should_validate: false,
        };
    },

    mounted() {
        this.setEventListeners();
        this.setDisabledClasses();

        if(this.modelValue) {
            this.textarea_value = this.modelValue;
            this.$refs["node"].classList.add("has-value")
            this.validate();
            this.setValidationClasses();
        }
    },

    watch: {
        modelValue(val) {
            if (val === this.textarea_value) {
                return;
            }

            this.textarea_value = val;

            this.validate();
            this.setValidationClasses();
        },

        validation() {
            this.validate();
            this.setValidationClasses();
        },

        disabled() {
            this.setDisabledClasses();
        },
    },

    methods: {
        handleInput() {
            if (this.validation && this.validation.length) {
                this.should_validate = true;
                this.validate();
                this.setValidationClasses();
            }

            this.$emit("update:modelValue", this.textarea_value, this.valid);
        },

        setValidationClasses() {
            if(this.loading) {
                return;
            }

            const el = this.$refs["node"];

            if(el) {
                if (this.error_message) {
                    el.classList.remove('valid');
                    el.classList.add('invalid');
                    return;
                }

                if (this.valid) {
                    el.classList.remove('invalid');
                    el.classList.add('valid');
                    return;
                }

                el.classList.remove('invalid');
                el.classList.remove('valid');
            }
        },

        setDisabledClasses() {
            if(this.loading) {
                return;
            }

            const el = this.$refs["node"];

            if(!el) {
                return;
            }

            if(this.disabled) {
                el.classList.add('disabled');
                return
            }

            el.classList.remove('disabled');
        },

        setEventListeners() {
            const el = this.$refs["node"];
            const textarea = this.$refs["textarea"]

            textarea.addEventListener("focus", () => {
                el.classList.add("focus");
            });

            textarea.addEventListener("blur", () => {
                if (textarea.value) {
                    el.classList.add("has-value");
                } else {
                    el.classList.remove("has-value");
                }

                el.classList.remove("focus");
            });
        },

        validate() {
            if(!this.should_validate) {
                return
            }

            const message = Validator.validate({
                validationArray: this.validation,
                value: this.textarea_value,
                name: this.name,
            });
            if (message) {
                this.error_message = message;
                this.$emit("error", this.error_message);
                this.valid = false;
                return;
            }

            this.error_message = null;
            this.valid = true;
            this.$emit("valid");
        },

        hasValidationErrors() {
            this.should_validate = true;
            this.validate();
            this.setValidationClasses();

            if (this.valid) {
                return false;
            }

            return true;
        },

        trimSpaces() {
            if(this.textarea_value) {
                this.textarea_value = this.textarea_value.trim();
            }
        },
    },

    template: /*html*/ `
    <div class="field textarea" ref="node">
        <label>{{title}}<span v-if="required">*</span></label>
        <textarea v-model="textarea_value" autocomplete="off" @input="handleInput" :placeholder="placeholder" ref="textarea" @change="trimSpaces" :disabled="disabled"></textarea>
        <div class="input-errors" v-html="error_message"></div>
    </div>
  `,
};

export default CustomTextarea;
